<template>
  <div>
    <!-- Vue-controlled Confirmation Modal -->
    <template v-if="confirmPackage.show">
      <!-- Backdrop positioned behind modal -->
      <div class="modal-backdrop fade show" @click="confirmPackage.handle('cancel')"></div>
      
      <div class="modal fade show" 
           style="display: block;" 
           tabindex="-1" 
           aria-labelledby="confirmationModalLabel" 
           aria-modal="true"
           @keydown.esc="confirmPackage.handle('cancel')">
        
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="confirmationModalLabel">{{confirmPackage.title}}</h5>
              <button type="button" class="btn-close" @click="confirmPackage.handle('cancel')" aria-label="Close"></button>
            </div>
            <form @submit.prevent="confirmPackage.handle('ok')">
              <div class="modal-body" v-html="confirmPackage.content"></div>
              <div class="modal-footer">
                <button v-if="showCancelButton" 
                        type="button" 
                        class="btn btn-secondary btn-sm" 
                        @click="confirmPackage.handle('cancel')">
                  {{confirmPackage.cancelLabel}}
                </button>
                <button type="submit" 
                        class="btn btn-primary btn-sm" 
                        @click="confirmPackage.handle('ok')">
                  {{confirmPackage.okLabel}}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </template>

    <!-- Vue-controlled Error Modal -->
    <template v-if="errorPackage.show">
      <!-- Backdrop positioned behind modal -->
      <div class="modal-backdrop fade show" @click="errorPackage.handle('cancel')"></div>
      
      <div class="modal fade show" 
           style="display: block;" 
           tabindex="-1" 
           aria-labelledby="errorModalLabel" 
           aria-modal="true"
           @keydown.esc="errorPackage.handle('cancel')">
        
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="errorModalLabel">{{errorPackage.title}}</h5>
              <button type="button" class="btn-close" @click="errorPackage.handle('cancel')" aria-label="Close"></button>
            </div>
            <form @submit.prevent="errorPackage.handle('cancel')">
              <div class="modal-body" v-html="errorPackage.content"></div>
              <div class="modal-footer">
                <button type="submit" 
                        class="btn btn-secondary btn-sm" 
                        @click="errorPackage.handle('cancel')">
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </template>

    <!-- Vue-controlled Toast -->
    <div class="toast-container fixed-top start-50 translate-middle-x mt-5">
      <div v-if="toastPackage.show" 
           class="toast simpletoast bg-primary text-white show" 
           role="alert" 
           aria-live="assertive" 
           aria-atomic="true">
        <div class="d-flex">
          <div class="toast-body" v-html="toastPackage.content"></div>
          <button type="button" 
                  class="btn-close btn-close-white me-2 m-auto" 
                  @click="closeToast" 
                  aria-label="Close"></button>
        </div>
      </div>
    </div>

    <TwoFactorAuth />
  </div>
</template>

<script>
import TwoFactorAuth from './account/TwoFactorAuth.vue';

export default {
  name: 'commonModals',
  props: {},
  data() {
    return {
      confirmPackage: {
        title: "",
        content: "",
        show: false,
        handle: null,
        okLabel: null,
        cancelLabel: null
      },
      errorPackage: {
        title: "",
        content: "",
        show: false,
        handle: null
      },
      toastPackage: {
        title: "",
        content: "",
        show: false,
        handle: null
      },
      toastTimeout: null
    }
  },

  methods: {
    injectGlobalMethods() {
      var me = this;
      console.log("Injecting common modals")
      window.VcCommonModals = (function() {
        return {
          showAlert(title, content, okLabel) {
            return me.showAlert(title, content, okLabel);
          },
          showConfirm(title, content, okLabel, cancelLabel) {
            return me.showConfirm(title, content, okLabel, cancelLabel);
          },
          showError(title, content) {
            return me.showError(title, content);
          },
          showToast(title, content) {
            return me.showToast(title, content);
          }
        }
      })();
    },

    showAlert(title, content, okLabel) {
      var me = this;
      return new Promise((resolve, reject) => {
        me.confirmPackage.title = title;
        me.confirmPackage.content = content;
        me.confirmPackage.okLabel = okLabel || "Ok";
        me.confirmPackage.cancelLabel = null;
        me.confirmPackage.show = true;
        me.confirmPackage.handle = function(id) {
          me.confirmPackage.show = false;
          if (id === 'cancel') {
            reject(id);
          } else {
            resolve(id);
          }
        }
      });
    },

    showConfirm(title, content, okLabel, cancelLabel) {
      var me = this;
      return new Promise((resolve, reject) => {
        me.confirmPackage.title = title;
        me.confirmPackage.content = content;
        me.confirmPackage.okLabel = okLabel || "Ok";
        me.confirmPackage.cancelLabel = cancelLabel || "Cancel";
        me.confirmPackage.show = true;
        me.confirmPackage.handle = function(id) {
          me.confirmPackage.show = false;
          if (id === 'cancel') {
            reject(id);
          } else {
            resolve(id);
          }
        }
      });
    },

    showToast(title, content) {
      var me = this;
      
      // Clear any existing timeout
      if (me.toastTimeout) {
        clearTimeout(me.toastTimeout);
      }
      
      me.toastPackage.title = title;
      me.toastPackage.content = content;
      me.toastPackage.show = true;
      me.toastPackage.handle = function(id) {
        me.closeToast();
      }

      // Auto-hide toast after 2.5 seconds 
      me.toastTimeout = setTimeout(() => {
        me.closeToast();
      }, 2500);
    },

    showError(title, content) {
      var me = this;
      me.errorPackage.title = title;
      me.errorPackage.content = content;
      me.errorPackage.show = true;
      me.errorPackage.handle = function(id) {
        me.errorPackage.show = false;
      }
    },

    closeToast() {
      this.toastPackage.show = false;
      if (this.toastTimeout) {
        clearTimeout(this.toastTimeout);
        this.toastTimeout = null;
      }
    },

    // Handle ESC key globally for modals
    handleGlobalKeyDown(event) {
      if (event.key === 'Escape') {
        if (this.confirmPackage.show) {
          this.confirmPackage.handle('cancel');
        } else if (this.errorPackage.show) {
          this.errorPackage.handle('cancel');
        }
      }
    }
  },

  computed: {
    showCancelButton() {
      return this.confirmPackage && this.confirmPackage.cancelLabel;
    }
  },

  mounted() {
    this.injectGlobalMethods();
    
    // Add global ESC key listener
    document.addEventListener('keydown', this.handleGlobalKeyDown);
  },

  beforeUnmount() {
    // Clean up event listener and timeouts
    document.removeEventListener('keydown', this.handleGlobalKeyDown);
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
    }
  },

  components: {
    TwoFactorAuth
  }
}
</script>

<style scoped>
/* Ensure proper z-index layering */
.modal-backdrop {
  z-index: 1040;
}

.modal {
  z-index: 1050;
}
</style>